module.exports = __webpack_public_path__ + "static/media/viadeo-square.966af552.svg";